// Libraries
import React, { forwardRef, HTMLInputTypeAttribute } from 'react'

// Styles
import { ErrorText, StyledInput, Wrap } from './style'

interface IProps {
  placeholder?: string;
  isError?: boolean;
  errorMessage?: string;
  autoFocus?: boolean;
}

export  const Input = forwardRef<HTMLInputTypeAttribute, IProps>(({
                                                                    isError,
                                                                    placeholder,
                                                                    errorMessage,
                                                                    autoFocus,
                                                                    ...props
                                                                  }, ref ) => {
  return (
    <Wrap>
      {isError && <ErrorText>{errorMessage}</ErrorText>}
      <StyledInput ref={ref as any} autoFocus={autoFocus} placeholder={placeholder} $isError={isError} {...props} />
    </Wrap>
  )
})